export const isDirectory = (key: string): boolean => {
  return key.endsWith('/');
};

export const getDisplayName = (key: string): string => {
  const isDir = isDirectory(key);
  if (isDir) {
    return getLastPathSegment(key.slice(0, -1));
  }
  return getLastPathSegment(key);
};

export const getLastPathSegment = (path: string): string => {
  const segments = path.split('/').filter(Boolean);
  return segments.length > 0 ? segments[segments.length - 1] : path;
};

export const removeFileExtension = (filename: string): string => {
  return filename.replace(/\.[^/.]+$/, '');
};

export const getParentPath = (key: string): string => {
  if (!key.includes('/')) return '';

  const lastSlashIndex = key.lastIndexOf('/');
  if (lastSlashIndex === 0) return '/';

  // For directories ending with '/', we need to get the parent of the directory itself
  if (isDirectory(key)) {
    const pathWithoutTrailingSlash = key.slice(0, -1);
    const parentSlashIndex = pathWithoutTrailingSlash.lastIndexOf('/');
    if (parentSlashIndex === -1) return '';
    return pathWithoutTrailingSlash.substring(0, parentSlashIndex + 1);
  }

  return key.substring(0, lastSlashIndex + 1);
};

export const buildNewKey = (oldKey: string, newName: string, isDirectory: boolean): string => {
  const parentPath = getParentPath(oldKey);

  if (isDirectory) {
    return `${parentPath}${newName}/`;
  }

  const lastDotIndex = oldKey.lastIndexOf('.');
  const extension =
    lastDotIndex > 0 && lastDotIndex > oldKey.lastIndexOf('/') ? oldKey.substring(lastDotIndex + 1) : undefined;
  return extension ? `${parentPath}${newName}.${extension}` : `${parentPath}${newName}`;
};

export const extractDisplayNames = (existingNames: string[]): string[] => {
  return existingNames.map((existing) => {
    const cleanPath = isDirectory(existing) ? existing.slice(0, -1) : existing;
    return cleanPath.split('/').pop() || cleanPath;
  });
};

export const generateUniqueName = (baseName: string, existingNames: string[]): string => {
  if (!existingNames.includes(baseName)) {
    return baseName;
  }

  for (let counter = 1; counter < 1000; counter++) {
    const candidateName = `${baseName}_${counter}`;
    if (!existingNames.includes(candidateName)) {
      return candidateName;
    }
  }

  return `${baseName}_${Date.now()}`;
};

export const ensureTrailingSlash = (path: string): string => {
  return isDirectory(path) ? path : `${path}/`;
};

export const getPathSeparator = (path: string): string => {
  return isDirectory(path) ? '' : '/';
};
